<template>
  <div class="tw-p-5 leading-tight">
    <swiper
        :allowTouchMove="false"
        @init="onInit"
        @swiper="onSwiper"
        @slideChangeTransitionEnd="onSlideChangeTransitionEnd">
      <swiper-slide>
        <div class="illustration d-flex justify-content-around align-items-center tw-mb-4">

          <i class="phone" v-if="Utils.isThemeBeepiz()" v-html="PhoneBeepizLogo"></i>
          <i class="phone" v-else-if="Utils.isThemeSfr()" v-html="PhoneSFRLogo"></i>
          <i class="phone" v-else v-html="PhoneNeutralLogo"></i>

          <div>
            <i class="fa fa-chevron-right"></i>
            <i class="fa fa-chevron-right"></i>
            <i class="fa fa-chevron-right"></i>
          </div>

          <i class="desktopLogo" v-if="Utils.isThemeBeepiz()" v-html="DesktopBeepizLogo"></i>
          <i class="desktopLogo" v-else-if="Utils.isThemeSfr()" v-html="DesktopSFRLogo"></i>
          <i class="desktopLogo" v-else v-html="DesktopNeutralLogo"></i>

        </div>
        <p class="explaination-1"
           v-html="$tc('device.registrations.assocExplaination1',getAvailableLicences , {count: getAvailableLicences,theme: Utils.getApplicationName()})">
        </p>
        <div class="d-flex py-2">
          <Btn class="secondary ml-auto" :class="{disabled:!datiId}"
               @click.native.stop="next">
            <span>{{ $t('global.next') }}</span> <i class="fa fa-chevron-right"></i>
          </Btn>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="messages" style="margin-top: 0; position: static;">
          <div class="message error show" v-if="!!backendErrorMessages.length">
            <i class="fa fa-times" @click="removeErrorsMessages()"></i>
            <i class="fa fa-exclamation-circle indicator"></i>
            <div class="message-inner">
              <div v-for="message in backendErrorMessages" v-text="message"></div>
            </div>
          </div>
        </div>
        <div class="form-row row standard">
          <label class="col-12">
            {{ $t('device.registrations.datiName') }}
          </label>
          <input ref="phone" type="text" v-model="datiName" class="form-input col-12"/>
        </div>
        <div class="form-row row standard">
          <label class="col-12">
            {{ $t('device.registrations.phonenumber') }} ({{ $t('global.optional') }})
          </label>
          <FormInputPhone
              v-model="phoneNumber"
              name="phoneNumber"
              @input="onPhoneInput"
              :isInvalid="phoneNumberShowError && phoneNumberIsInvalid"
              @blur="blurPhoneInput()"
          />
          <FormError v-if="phoneNumberShowError && phoneNumberIsInvalid">
            {{ $t('device.registrations.errors.invalidPhoneFormat') }}
          </FormError>
        </div>
        <div class="form-row row standard">
          <label class="col-12">
            {{ $t('device.registrations.profile') }}
          </label>
          <select class="form-input col-12" v-model="datiProfile">
            <option :value="null">{{ $t('device.registrations.profileSelectPlaceholder') }}</option>
            <option v-for="profile in props.profiles" :value="profile.profileId">{{ profile.meta.name }}</option>
          </select>
        </div>
        <div class="form-row row standard">
          <label class="col-12">
            {{ $t('device.groupSelect') }}
          </label>
          <select class="form-input col-12" v-model="datiGroup">
            <option value="null">{{ $t('device.noGroup') }}</option>
            <option v-for="group in props.groups" :value="group.id">{{ group.name }}</option>
          </select>
        </div>
        <div class="form-row row standard" v-if="hasAnalytic">
          <label class="col-12">
            {{ $t('device.registrations.analyticCode') }}
          </label>
          <input ref="analytic" type="text" maxlength="30" v-model="analyticCode" class="form-input col-12"/>
        </div>
        <div class="d-flex py-2">

          <Btn class="secondary prev-button "
               @click.native.stop="prev">
            <i class="fa fa-chevron-left"></i> <span>{{ $t('global.prev') }}</span>
          </Btn>
          <Btn class="secondary ml-auto"
               @click.native.stop="next"
               :class="(!phoneNumberIsInvalid || phoneNumberNationnal ===undefined) ? '' : 'disabled' "
          >
            <span>{{ $t('global.next') }}</span> <i class="fa fa-chevron-right"></i>
          </Btn>
        </div>

      </swiper-slide>
      <swiper-slide>
        <p class="explaination-2 mt-0 mb-2">
        </p>
        <div class="qrcode-container">
          <div :class="'qrcode-inner'">
            <LoadingMini ref="loading"></LoadingMini>
            <QRCode :text="code" :size="150" :color="'#212121'" :class="{show:code != ''}"
                    :bg-color="'#FFFFFF'" :error-level="'Q'"></QRCode>
          </div>
          <p class="mt-0 mb-1">
            <a :href="code" target="_blank">{{ code }}</a>
          </p>
          <span v-if="code != ''" class="text-info-600">
            <span>{{ $t("device.registrations.expiresIn") }}</span>
            <Countdown :date="liveUntil" @expired="handleExpired"></Countdown>
          </span>
        </div>

        <p
            class="explaination-3 my-2"
            v-html="$t('device.registrations.assocExplaination3')"
        ></p>
        <div class="center">
          <Btn class="primary reverse">
            <router-link :to="getDatiLink" tag="div"><i class="fa fa-mobile-phone"></i>
              <span>{{ $t('device.btns.goToShow') }}</span></router-link>
          </Btn>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import axios from 'axios';
import API from '@/services/API.js';
import Toolbar from "@/components/ui/Toolbar";
import Btn from "@/components/ui/Button";
import QRCode from 'vue-qrcode-component';
import LoadingMini from '@/components/ui/LoadingMini';
import Countdown from '@/components/ui/Countdown';
import {FormInputPhone, FormError, FormControl, FormLabel} from '@/components/ui/forms';

import {mixin as clickaway} from 'vue-clickaway';
import 'moment-timezone';

import _find from 'lodash/find';

import picto_standard from '@/assets/img/picto/1_Standard_yellow.svg'
import picto_premium from '@/assets/img/picto/2_Premium_yellow.svg'
import picto_enterprise from '@/assets/img/picto/3_Enterprise_yellow.svg'

import {Swiper, SwiperSlide} from 'swiper-vue2'
import Utils from "../../services/utils";
import DesktopSFRLogo from '@/assets/img/desktop-sfr-dati.svg';
import DesktopBeepizLogo from '@/assets/img/desktop-beepiz.svg';
import DesktopNeutralLogo from '@/assets/img/desktop-neutral.svg';
import PhoneBeepizLogo from '@/assets/img/phone-beepiz.svg';
import PhoneSFRLogo from '@/assets/img/phone-sfr-dati.svg';
import PhoneNeutralLogo from '@/assets/img/phone-neutral.svg';
import {useDvFlagAccess} from "../../services/featureFlag";

export default {
  components: {
    Toolbar,
    Btn,
    QRCode,
    Swiper,
    SwiperSlide,
    LoadingMini,
    Countdown,
    DesktopSFRLogo,
    DesktopBeepizLogo,
    DesktopNeutralLogo,
    PhoneBeepizLogo,
    PhoneSFRLogo,
    PhoneNeutralLogo,
    FormInputPhone,
    FormError,
    FormControl,
    FormLabel
  },
  computed: {
    Utils() {
      return Utils
    },
    DesktopSFRLogo() {
      return DesktopSFRLogo
    },
    DesktopBeepizLogo() {
      return DesktopBeepizLogo
    },
    DesktopNeutralLogo() {
      return DesktopNeutralLogo
    },
    PhoneBeepizLogo() {
      return PhoneBeepizLogo
    },
    PhoneSFRLogo() {
      return PhoneSFRLogo
    },
    PhoneNeutralLogo() {
      return PhoneNeutralLogo
    },
    pictoStandard() {
      return picto_standard
    },
    pictoPremium() {
      return picto_premium
    },
    pictoEnterprise() {
      return picto_enterprise
    },
    hasAnalytic: function () {
      return window.V.clientInfos.beepiz_analytic_code
    },
    isMultiLicenceTypes: function () {
      if (Object.keys(this.props.availableLicences).length > 1) {
        return true;
      }
      return false;
    },
    getAvailableLicences: function () {
      var ret = 0;
      for (var lic in this.props.availableLicences) {
        ret += this.props.availableLicences[lic].nbDispoWithoutOption;
        if (Object.keys(this.props.availableLicences[lic].options).length > 0) {
          for (var opt in this.props.availableLicences[lic].options) {
            ret += this.props.availableLicences[lic].options[opt].nbDispo;
          }
        }
      }
      return ret;
    },
    getDatiLink() {
      if (this.datiId) {
        return '/devices/' + this.datiId + '?fromRegistration=1';
      } else {
        return '#';
      }

    }
  },
  data() {
    return {
      code: '',
      phoneNumber: null,
      phoneNumberNationnal: null,
      phoneNumberIsInvalid: false,
      phoneNumberShowError: false,
      datiId: null,
      datiName: '',
      datiProfile: null,
      datiGroup: null,
      analyticCode: '',
      liveUntil: null,
      showLicences: false,
      firstTimeLicences: true,
      isLoading: false,
      backendErrorMessages: []
    }
  },
  destroyed: function () {
  },
  methods: {
    blurPhoneInput() {
      this.phoneNumberShowError = this.phoneNumberNationnal !== undefined &&
          this.phoneNumberNationnal.length > 0;
    },
    onPhoneInput: function (value, objectValue) {
      this.phoneNumberNationnal = objectValue.nationalNumber
      this.phoneNumberIsInvalid = !objectValue.valid;
    },
    next: function () {
      this.backendErrorMessages = []
      this.$refs.swiper.slideNext();
    },
    prev: function () {
      this.$refs.swiper.slidePrev();
    },
    onInit: function (swiper) {
      this.$refs.loading.show();
      if (this.props.dati != null && this.props.dati.status == 1) {
        this.loadLink();
        swiper.slideTo(2, 0, false)
      }
      if (this.props.dati != null && this.props.dati.status == 0) {
        swiper.slideTo(0, 0, false)
      }
    },
    onSwiper: function (swiperRef) {
      this.$refs.swiper = swiperRef;
    },
    onSlideChangeTransitionEnd: function (swiper) {
      if (swiper.activeIndex == 2) {
        this.$refs.loading.show();
        this.loadLink();
      }
    },
    loadLink: function () {
      var objToAdd = {
        datiId: null,
        datiName: [this.datiName],
        profileId: this.datiProfile,
        groupId: this.datiGroup,
        analyticCode: [this.analyticCode],
        type_registration: "qrcode"
      }
      if (this.phoneNumberIsInvalid !== undefined && !this.phoneNumberIsInvalid) {
        objToAdd.recipients = [this.phoneNumber]
      }

      if (this.props != null && this.props.dati != null) {
        objToAdd.datiId = this.props.dati.id;
        objToAdd.analyticCode = this.props.dati.analyticCode ? [this.props.dati.analyticCode] : [''];
      }

      if (!this.isLoading) {
        this.isLoading = true;

        axios.post(API.endpoints.licences.add, objToAdd)
            .then(response => {
              if (response.data.registration != null) {
                this.code = response.data.registration.shortLink;
                this.datiId = response.data.registration.datiId;
                this.liveUntil = response.data.registration.liveUntil;
              } else {
                this.code = response.data.message.shortLink;
                this.datiId = response.data.message.datiId;
                this.liveUntil = response.data.message.liveUntil;
              }
              this.isLoading = false;
              this.$refs.loading.hide();
            })
            .catch(error => {
              this.isLoading = false;
              this.$refs.loading.hide();
              if (objToAdd.datiId !== null && error.response.status == 422 && error.response.data?.message == "phone_number_already_in_use") {
                this.backendErrorMessages.push(window.V.$i18n.t('device.registrations.errors.phone_number_already_in_use'));
                this.prev()
              } else {
                window.Vfc.$refs.messages.sendMessage('error', window.V.$i18n.t('errors.default'));
                window.Vfc.$refs.modal.hide()
              }
            })
      }
    },
    getAvailableLicencesByType(licenceType, optionType) {
      //return this.props.availableLicences[licenceType].nbDispoWithoutOption;
      if (optionType != null) {
        return this.props.availableLicences[licenceType].options[optionType].nbDispo;

      } else {
        return this.props.availableLicences[licenceType].nbDispoWithoutOption;

      }
    },
    handleExpired: function () {
      this.$refs.swiper.slideTo(2)
      this.code = '';
    },
    toggleLicences: function () {
      this.showLicences = !this.showLicences;
      if (this.showLicences) {
        this.firstTimeLicences = false;
      } else {
        this.firstTimeFilters = true;
      }
    },

    closeLicences: function () {
      if (this.showLicences && !this.firstTimeLicences) {
        this.showLicences = false;
        this.firstTimeLicences = true;
      } else {
        this.firstTimeLicences = false;
      }
    },
    removeErrorsMessages: function () {
      this.backendErrorMessages = [];
    },
  },
  mixins: [clickaway],
  mounted() {
    if (this.props != null && this.props.dati != null) {
      this.datiId = this.props.dati.id
      this.datiName = this.props.dati.name
      this.analyticCode = this.props.dati.analyticCode
      if (this.props.dati.profileId != null) {
        this.datiProfile = _find(this.props.profiles, o => {
          return o.profileId == this.props.dati.profileId
        }).profileId
      }
      if (this.props.dati.groupId != null) {
        this.datiGroup = _find(this.props.groups, o => {
          return o.id == this.props.dati.groupId
        }).id
      }
    }
  },
  name: '',
  props: {
    props: {
      type: Object,
      default: function () {
        return {
          dati: null,
          availableLicences: {},
          profiles: [],
          groups: []
        }
      }
    }
  },
  updated: function () {
  },
  watch: {
    props: function (newValue, oldValue) {

      this.showLicences = false;
      this.firstTimeLicences = true;
      this.code = '';
      if (this.props != null && this.props.dati != null) {
        this.datiName = this.props.dati.name
      }
      this.$refs.swiper.activeIndex = 0;
      if (this.props.dati != null && this.props.dati.status == 1) {
        this.loadLink();
        this.$refs.swiper.activeIndex = 2;
      }
      if (this.props.dati != null && this.props.dati.status == 0) {
        this.$refs.swiper.activeIndex = 0;
      }
      if (this.props.dati != null) {
        if (this.props.dati.profileId != null) {
          this.datiProfile = _find(this.props.profiles, o => {
            return o.profileId == this.props.dati.profileId
          }).profileId
        }
        if (this.props.dati.groupId != null) {
          this.datiGroup = _find(this.props.groups, o => {
            return o.id == this.props.dati.groupId
          })
        }
      } else {
        this.datiId = null
        this.datiName = ''
        this.datiProfile = null
        this.datiGroup = null
        this.analyticCode = ''
      }
    }
  }
}
</script>

<style lang="css">
.phone > svg {
  height: 100px;
  width: 100px;
}

.desktopLogo > svg {
  height: 100px;
  width: 150px;
}
</style>
